<template>
	<div class="">
		<Header></Header>
		<div class="fenbg">
			<img src="../assets/home/bg4.png" alt="" height="225px">
		</div>
		<!--标题-->
		<div class="fentitle">
			<p>关于曲靖分校</p>
			<p>About Qujing school </p>
		</div>
		<!--内容-->
		<div class="fentxt">
			<p>
				大齐国位处东洲大陆东部凸出的半岛上，和炎国、煌国共处同一区域，全都背靠东海汪洋，西朝蛮族荒原，故而这数百年来互为联盟之势，常常共进退。
				　　大齐位于半岛中心位置，被其他两国正好夹持在中间位置，但国力最盛，号称有百万常备甲军，煌国次之，炎国最弱。
				　　大齐除了直辖的京城区域外，下面区域共划分九府三十六州，每州又各自管辖数座到十几座不一的城池，至于乡镇村落，更是不计其数了。
				　　丰城是泉州境内第一大城，也是泉州的州城，即使在整个开元府也能排进前五之列。
				　　金家更是泉州豪门之一，在城外拥有大量田地和庄园，也从事一些药草矿石的卖卖，势力几乎能影响到小半泉州。
				　　这一切，是石牧从青衫老者口中得知的。
				　　此时的他，已经知道老者叫金成，是金家的一名外事管家，在金家下人中似乎颇有些地位，起码那几名金家骑士全都对其十分恭敬。
				　　一行人足足在路上走了月许时间，一连穿越了两座城池后，终于来到了丰城，并直接穿越城门，往城中西北角方向而去。
				　　石牧坐在马车窗口处，向街道两侧打量个不停。
				　　他从小就在渔村长大，几乎没出过远门，以前去过的最大城市，也即是附近的县城了。
				　　丰城不愧为泉州最大的城池，街道两旁尽是高大的各式建筑，路边两侧行人也是熙熙攘攘
			</p>
		</div>
		<div class="fenline"></div>
		<div class="fenlist">
			<ul>
				<li v-for="(item,index) in 4" :key='index' @click="openinfo()">
					<div class="fenbg">
						<img src="../assets/home/scholl.jpg" alt="">
					</div>
					<div class="fentxt">
						<p>就暗示的健康期望iOS开了大是的撒即可领导</p>
					</div>
					<div class="feninfo">
						<p>下面区域共划分九府三十六州，每州又各自管辖数座到十几座不一的城池</p>
					</div>
				</li>
			</ul>
		</div>
		<div class="fenline"></div>
		<div class="fenaddres w95">
			地图盒子
		</div>
		<div class="feninfo w95">
			<ul>
				<li>
					<p>曲靖校区详细地址：</p>
					<p>曲靖市经开发曲靖师范学院正后门对面（崔家屯社区）</p>
				</li>
				<li>
					<p>全国统一联系电话：</p>
					<p>0871-6253635</p>
				</li>
				<li>
					<p>曲靖分校联系电话：</p>
					<p>184-6421-2233</p>
				</li>
				<li>
					<p>附近公交站，打车地点：</p>
					<p>下马村公交站，万彩城一栋</p>
				</li>

			</ul>
		</div>
		<Fotter></Fotter>

	</div>
</template>

<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	export default {
		name: 'Fenzhan',
		components: {
			Header,
			Fotter
		},
		data() {
			return {

			}

		},
		methods: {
           openinfo(){
			       this.$router.push({  
					path: '/FenDetail',   
					name: 'FenDetail',  
				})  
		   }
		}
	}
</script>

<style scoped>
	.fenbg {
		width: 100%;
		height: 225px;
	}

	.fenbg img {
		width: 100%;
		height: 100%;
	}

	.fentitle {
		width: 100%;
		height: 60px;
		margin-top: 20px;
	}

	.fentitle p {
		text-align: center;
	}

	.fentitle p:nth-child(1) {
		font-size: 15px;
		font-weight: 600;
		line-height: 21px;
		color: rgba(51, 51, 51, 1);
	}

	.fentitle p:nth-child(2) {
		font-size: 10px;
		font-weight: 300;
		line-height: 30px;
		color: rgba(204, 204, 204, 1);
	}

	.fentxt {
		width: 95%;
		margin: 0 auto;
	}

	.fentxt p {

		font-size: 12px;
		font-weight: 300;
		line-height: 25px;
		color: rgba(102, 102, 102, 1);
	}

	.fenline {
		width: 95%;
		margin: 10px auto;
		height: 0px;
		border: 1px solid rgba(204, 204, 204, 1);
	}

	.fenlist {
		height: auto;

		margin: 10px auto 20px auto;
	}

	.fenlist ul li {
		width: 48%;
		background: rgba(255, 255, 255, 1);
		-webkit-box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.1);
		box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.1);
		opacity: 1;
		display: inline-block;
		border-radius: 7px;
		margin-top: 10px;

	}

	.fenlist ul li:nth-child(even) {
		margin-left: 7px;
	}

	.fenlist ul li:nth-child(odd) {
		margin-left: 5px;
	}

	.fenlist ul li .fenbg {
		width: 100%;
		height: 91px;
	}

	.fenlist ul li .fenbg img {
		width: 100%;
		height: 91px;
	}

	.fenlist ul li .fentxt {
		width: 95%;
	}

	.fenlist ul li .fentxt p {
		font-size: 13px;
		font-weight: 600;
		line-height: 21px;
		color: rgba(51, 51, 51, 1);
		margin: 10px;
	}

	.fenlist ul li .feninfo {
		width: 95%;
		margin: 10px;
	}

	.fenlist ul li .feninfo p {
		font-size: 10px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(153, 153, 153, 1);
	}

	.fenaddres {
		margin: 10px auto;
		height: 161px;
		background: #fff;
		overflow: hidden;
	}

	.fenaddres img {
		width: 100%;
		height: 100%;
	}

	.feninfo {
		margin: 10px auto;
	}

	.feninfo ul li p:nth-child(1) {
		font-size: 14px;
		font-weight: 600;
		line-height: 28px;
		color: rgba(51, 51, 51, 1);
	}

	.feninfo ul li p:nth-child(2) {
		font-size: 12px;
		font-weight: 300;
		line-height: 20px;
		color: rgba(102, 102, 102, 1);
	}
</style>



// WEBPACK FOOTER //
// src/components/Fenzhan.vue